var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 20C7 21.1046 7.89543 22 9 22L16.6257 22L19.001 22C20.1055 22 21.001 21.1046 21.001 20L21.001 17.3125L21.001 9C21.001 7.89543 20.1055 7 19.001 7L9 7C7.89543 7 7 7.89543 7 9L7 20Z",
    fill: "#1FD7AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 18L4 18C2.89543 18 2 17.1046 2 16L2 4C2 2.89543 2.89543 2 4 2L15 2C16.1046 2 17 2.89543 17 4L17 5L7 5C5.89543 5 5 5.89543 5 7L5 18Z",
    fill: "#1FD7AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.4cf1bd58.svg";
export { ForwardRef as ReactComponent };